export default __webpack_public_path__ + "static/media/EN.7be3d5a2.png";